module.exports = __webpack_public_path__ + "static/media/pos_about_img.b39f3517.png";